<template>
  <div class="ancet" >
    <form class="ancet__form ancet-form" v-if="ancet && !ancetSended">
      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">ФИО заявителя</label>
        <div class="row gx-1">
          <div class="col-md-4">
            <div
              v-bind:class="{ 'form-group--invalid': errors.second_name }"
              class="ancet-form__form-group form-group">
              <input
                v-model="ancet.second_name"
                @change="saveAncet(false)"
                placeholder="Фамилия"
                type="text" class="form-group__input form-control">
              <p class="form-group__error-message invalid-feedback" v-if="errors.second_name">
                {{ errors.second_name.join(', ') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div
              v-bind:class="{ 'form-group--invalid': errors.first_name }"
              class="ancet-form__form-group form-group">
              <input
                v-model="ancet.first_name"
                @change="saveAncet(false)"
                placeholder="Имя"
                type="text" class="form-group__input form-control">
              <p class="form-group__error-message invalid-feedback" v-if="errors.first_name">
                {{ errors.first_name.join(', ') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div
              v-bind:class="{ 'form-group--invalid': errors.third_name }"
              class="ancet-form__form-group form-group">
              <input
                v-model="ancet.third_name"
                @change="saveAncet(false)"
                placeholder="Отчество"
                type="text" class="form-group__input form-control">
              <p class="form-group__error-message invalid-feedback" v-if="errors.third_name">
                {{ errors.third_name.join(', ') }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">Состав семьи</label>
        <help-label>
          <template v-slot:header>
            Супруг, дети
          </template>
          <template v-slot:body>
            <p>ФИО мужа/жены и детей</p>
          </template>
        </help-label>
        <family-persons
          :ancet-id="ancet.id"
          class="ancet-form__family-persons"></family-persons>
      </div>

      <div
        v-bind:class="{ 'form-group--invalid': errors.inn }"
        class="ancet-form__form-group form-group">
        <label class="form-group__label">ИНН заявителя</label>
        <input
          v-model="ancet.inn"
          @change="saveAncet(false)"
          placeholder="12 цифр"
          type="text" class="form-group__input form-control">
        <p class="form-group__error-message invalid-feedback" v-if="errors.inn">
          {{ errors.inn.join(', ') }}</p>
      </div>

      <div
        v-bind:class="{ 'form-group--invalid': errors.register_address }"
        class="ancet-form__form-group form-group mb-5">
        <label class="form-group__label">Прописка заявителя</label>
        <textarea
          v-model="ancet.register_address"
          @change="saveAncet(false)"
          placeholder="Область, город, улица, дом, квартира"
          class="form-group__textarea form-control"></textarea>
        <p class="form-group__error-message invalid-feedback" v-if="errors.register_address">
          {{ errors.register_address.join(', ') }}</p>
      </div>

      <div class="ancet-form__fieldset fieldset fieldset-contacts">
        <label class="fieldset__label">Контакты заявителя</label>
        <div class="row gx-1">
          <div class="col-sm-6">
            <div
              v-bind:class="{ 'form-group--invalid': errors.phone }"
              class="ancet-form__form-group form-group">
              <input
                v-model="ancet.phone"
                @change="saveAncet(false)"
                v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx"
                type="text" class="form-group__input form-control">
              <p class="form-group__error-message invalid-feedback" v-if="errors.phone">
                {{ errors.phone.join(', ') }}</p>
            </div>
          </div>
          <div class="col-sm-6">
            <div
              v-bind:class="{ 'form-group--invalid': errors.email }"
              class="ancet-form__form-group form-group">
              <input
                v-model="ancet.email"
                @change="saveAncet(false)"
                placeholder="email"
                type="text" class="form-group__input form-control">
              <p class="form-group__error-message invalid-feedback" v-if="errors.email">
                {{ errors.email.join(', ') }}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-bind:class="{ 'form-group--invalid': errors.ancet_type }"
        class="ancet-form__form-group form-group mb-5">
        <label class="form-group__label">Форма собственности</label>
        <help-label>
          <template v-slot:header>
          </template>
          <template v-slot:body>
            <p>Если уже зарегистрировано ИП, укажите дату постановки на учет, систему налогооблажения и вид деятельности.</p>
            <p>Если зарегистрированы как самозанятый, укажите дату регистрации.</p>
            <p>Иначе выбирайте "Не зарегистрирован".</p>
          </template>
        </help-label>
        <select
          v-model="ancet.ancet_type"
          @change="saveAncet(false)"
          class="form-group__input form-control">
          <option :value="null">Выбрать</option>
          <option :value="'person'">Не зарегистрирован</option>
          <option :value="'ip'">ИП</option>
          <option :value="'sz'">Самозанятость</option>
        </select>
        <p class="form-group__error-message invalid-feedback" v-if="errors.ancet_type">
          {{ errors.ancet_type.join(', ') }}</p>
      </div>

      <div
        class="ancet-form__fieldset fieldset"
        v-if="ancet.ancet_type == 'ip'">
        <label class="fieldset__label">Информация по ИП</label>
        <div
          v-bind:class="{ 'form-group--invalid': errors.ip_date_register }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">Дата регистрации ИП</label>
          <input
            v-model="ipDateRegister"
            @change="saveAncet(false)"
            v-mask="'##.##.####'" placeholder="дд.мм.гггг"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.ip_date_register">
            {{ errors.ip_date_register.join(', ') }}</p>
        </div>

        <div
          v-bind:class="{ 'form-group--invalid': errors.ip_tax }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">Налогооблажение</label>
          <select
            v-model="ancet.ip_tax"
            @change="saveAncet(false)"
            class="form-group__input form-control">
            <option :value="null">Выбрать</option>
            <option :value="'usn'">УСН</option>
            <option :value="'patent'">Патент</option>
            <option :value="'tradition'">Общее</option>
          </select>
          <p class="form-group__error-message invalid-feedback" v-if="errors.ip_tax">
            {{ errors.ip_tax.join(', ') }}</p>
        </div>

        <div
          v-bind:class="{ 'form-group--invalid': errors.ip_okved }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">
            ОКВЭД ИП
            <help-label>
              <template v-slot:header>
                Вид деятельности ИП
              </template>
              <template v-slot:body>
                <p>Если знаете основной ОКВЭД вашего ИП, укажите код. Если не знаете, напишите словами вид деятельности, который планируется по бизнес-плану.</p>
              </template>
            </help-label>
          </label>
          <input
            v-model="ancet.ip_okved"
            @change="saveAncet(false)"
            placeholder="Основной вид деятельности"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.ip_okved">
            {{ errors.ip_okved.join(', ') }}</p>
        </div>
      </div>

      <div
        class="ancet-form__fieldset fieldset"
        v-if="ancet.ancet_type == 'sz'">
        <label class="fieldset__label">Самозанятость</label>
        <div
          v-bind:class="{ 'form-group--invalid': errors.sz_date_register }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">Дата регистрации</label>
          <input
            v-model="szDateRegister"
            @change="saveAncet(false)"
            v-mask="'##.##.####'" placeholder="дд.мм.гггг"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.sz_date_register">
            {{ errors.sz_date_register.join(', ') }}</p>
        </div>

        <div
          v-bind:class="{ 'form-group--invalid': errors.sz_business }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">
            Вид деятельности
            <help-label>
              <template v-slot:header>

              </template>
              <template v-slot:body>
                <p>Укажите вид деятельности, которым собираетесь заниматься.</p>
              </template>
            </help-label>
          </label>
          <input
            v-model="ancet.sz_business"
            @change="saveAncet(false)"
            placeholder="Основной вид деятельности"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.sz_business">
            {{ errors.sz_business.join(', ') }}</p>
        </div>
      </div>

      <div
        class="ancet-form__fieldset fieldset"
        v-if="ancet.ancet_type == 'person'">

        <div
          v-bind:class="{ 'form-group--invalid': errors.type_business }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">
            Вид деятельности
            <help-label>
              <template v-slot:header>

              </template>
              <template v-slot:body>
                <p>Укажите вид деятельности, которым собираетесь заниматься.</p>
              </template>
            </help-label>
          </label>
          <input
            v-model="ancet.type_business"
            @change="saveAncet(false)"
            placeholder="По бизнес-плану"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.type_business">
            {{ errors.type_business.join(', ') }}</p>
        </div>
      </div>

      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">Ваши услуги (прайс)</label>
        <help-label>
          <template v-slot:header>
          </template>
          <template v-slot:body>
            <p>3-4 услуги или товара, которые планируете продавать (прайс-лист).</p>
            <p>Например: <br>свадебная фотосъемка - <nobr>6000 руб / час</nobr><br>маникюр - 2000 руб</p>

          </template>
        </help-label>
        <services
          :ancet-id="ancet.id"
          class="ancet-form__services"></services>
      </div>

      <div
        v-bind:class="{ 'form-group--invalid': errors.business_place }"
        class="ancet-form__form-group form-group mb-4">
        <label class="form-group__label">
          Место деятельности
          <help-label>
            <template v-slot:header>
            </template>
            <template v-slot:body>
              <p>Если планируете вести деятельность дома, так и выбирайте.</p>
              <p>Если потребуется аренда помещения или помещение уже арендовано, укажите адрес и стоимость аренды в месяц.</p>
            </template>
          </help-label>
        </label>
        <select
          v-model="ancet.business_place"
          @change="saveAncet(false)"
          class="form-group__input form-control">
          <option :value="null">Выбрать</option>
          <option :value="'home'">Дома</option>
          <option :value="'rent'">Аренда помещения</option>
        </select>
        <p class="form-group__error-message invalid-feedback" v-if="errors.business_place">
          {{ errors.business_place.join(', ') }}</p>
      </div>

      <div
        class="ancet-form__fieldset fieldset"
        v-if="ancet.business_place == 'rent'">

        <div
          v-bind:class="{ 'form-group--invalid': errors.place_price }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">Стоимость аренды</label>
          <input
            v-model="ancet.place_price"
            @change="saveAncet(false)"
            placeholder="в месяц"
            type="text" class="form-group__input form-control">
          <p class="form-group__error-message invalid-feedback" v-if="errors.place_price">
            {{ errors.place_price.join(', ') }}</p>
        </div>

        <div
          v-bind:class="{ 'form-group--invalid': errors.place_address }"
          class="ancet-form__form-group form-group">
          <label class="form-group__label">Адрес аренды</label>
          <textarea
            v-model="ancet.place_address"
            @change="saveAncet(false)"
            placeholder="город, улица, дом"
            class="form-group__input form-control"></textarea>
          <p class="form-group__error-message invalid-feedback" v-if="errors.place_address">
            {{ errors.place_address.join(', ') }}</p>
        </div>
      </div>

      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">Образование заявителя</label>
        <help-label>
          <template v-slot:header>
          </template>
          <template v-slot:body>
            <p>Где и на кого учились</p>
          </template>
        </help-label>
        <education
          :ancet-id="this.ancet.id"></education>
      </div>

      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">Опыт работы</label>
        <help-label>
          <template v-slot:header>
          </template>
          <template v-slot:body>
            <p>Где работали. По трудовой и нет.</p>
          </template>
        </help-label>
        <work-experience
          :ancet-id="this.ancet.id"></work-experience>
      </div>

      <div class="ancet-form__fieldset fieldset">
        <label class="fieldset__label">Что планируете закупать?</label>
        <help-label>
          <template v-slot:header>
            Что планируете закупать на средства соцконтракта
          </template>
          <template v-slot:body>
            <p>На 350&nbsp;000 руб.</p>
            <p><strong>МАКСИМАЛЬНЫЕ суммы</strong></p>
            <ul>
              <li>52&nbsp;500 – аренда;</li>
              <li>52&nbsp;500 – расходники;</li>
              <li>17&nbsp;500 – вывеска (реклама) – больше НЕ ДАДУТ!</li>
              <li>15&nbsp;000 – ремонт (больше НЕ ДАДУТ)</li>
              <li>
                <div>212&nbsp;500 – оборудование и мебель (необходимо перечислить)</div>
                <div>(«стол – 15000руб/1шт»)</div>
              </li>
              <p>Либо все 350&nbsp;000 – оборудование (с ценами и кол-вом). Например: аппарат для эпиляции – 350&nbsp;000.</p>
              <p>Если Вы этого не предоставляете, то мы пишем сами, и исправляем по ВАШЕМУ желанию ПЛАТНО.</p>
              <p class="text-error">Телефоны, раковины, телевизоры не пишите!</p>
            </ul>
          </template>
        </help-label>
        <calculation
          :ancet-id="this.ancet.id"></calculation>
      </div>

      <div class="ancet-form__actions ancet-actions">
        <button
          type="button"
          @click="saveAncet(sended=true)"
          class="btn btn--primary ancet-actions__btn-submit">Отправить анкету</button>

        <button
          title="Скопировать ссылку на анкету"
          type="button"
          @click="getPasswordLink()"
          class="btn btn--surface-container ancet-actions__btn-copy-link">
            <i class="fa fa-copy" v-if="!copied"></i><i class="fa fa-check" v-if="copied"></i>&nbsp;Ссылка на анкету
          </button>

          <div class="ancet-actions__legal">Отправляя анкету, вы принимаете <a href="/legal/">условия обработки персональных данных</a>.</div>
      </div>

    </form>
    <div class="ancet__sended-message sended-ancet" v-if="ancet && ancetSended">
      <div class="sended-ancet__message">Анкета заполнена и отправлена. Если необходимо, вы можете отредактировать анкету и отправить повторно. Сохраните ссылку на анкету, чтобы вы могли отредактировать ее позднее.</div>
      <div class="sended-ancet__actions">
        <button
          @click="editAncet()"
          class="btn btn--primary sended-ancet__edit-ancet" type="button">Редактировать анкету</button>
      </div>
      <div class="sended-ancet__link-label">Ссылка на анкету:</div>
      <div class="sended-ancet__password-link" v-if="ancet.link_password ">
        {{ ancet.get_absolute_url }}
        <button
          title="Скопировать ссылку на анкету"
          type="button"
          v-if="!copied"
          @click="getPasswordLink()"
          class="sended-ancet__copy-link">
            <i class="fa fa-copy"></i>
          </button>
          <button
          title="Скопировать ссылку на анкету"
          type="button"
          v-if="copied"
          @click="getPasswordLink()"
          class="sended-ancet__copy-link sended-ancet__copy-link--success">
            <i class="fa fa-check"></i>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import Vue from 'vue'
import VueScrollTo from "vue-scrollto"

import UtilsMixin from './mixins/UtilsMixin.vue'
import HelpLabel from './HelpLabel.vue'
import FamilyPersons from './FamilyPersons.vue'
import Services from './Services.vue'
import Education from './Education.vue'
import WorkExperience from './WorkExperience.vue'
import Calculation from './Calculation.vue'

Vue.use(VueScrollTo)


export default {

  name: 'Ancet',

  mixins: [UtilsMixin],

  props: {
    ancetId: {
      type: Number,
      default: null
    },
    token: {
      type: String,
      default: null
    }
  },

  components: {
    HelpLabel,
    FamilyPersons,
    Services,
    Education,
    WorkExperience,
    Calculation
  },

  data () {
    return {
      ancet: null,
      ipDateRegister: null,
      szDateRegister: null,
      errors: {},
      ancetSended: false,
      copied: false,
      tokenInstance: null
    }
  },

  mounted () {

    if (this.token) {
      this.tokenInstance = this.token
    }

    if (this.ancetId) {
      axios.get(`/ancet/api/ancet/${this.ancetId}/`, {params: {token: this.tokenInstance}})
        .then(response => {
          this.ancet = response.data
          this.prepareForm()
        })
        .catch(error => {
          this.errors = error.response.data
        })
    } else {
      this.ancet = {
        id: null,
        second_name: null,
        first_name: null,
        third_name: null,
        inn: null,
        register_address: null,
        email: null,
        phone: null,
        ancet_type: null,
        get_ancet_type_display: null,
        ip_date_register: null,
        ip_okved: null,
        ip_tax: null,
        sz_business: null,
        sz_date_register: null,
        type_business: null,
        business_place: null,
        get_business_place_display: null,
        place_address: null,
        place_price: null,
        sended: false,
        created: null,
        send_date: null,
        family_persons: [],
        services: [],
        education: [],
        work_experience: [],
        calculation_items: []
      }
    }
  },

  methods: {
    saveAncet (sended=false) {

      this.ancet.sended = sended

      if (this.ipDateRegister && this.ipDateRegister.length > 0) {
        this.ancet.ip_date_register = this.formatDate(new Date(this.ipDateRegister))
      }
      else {
        this.ancet.ip_date_register = null
      }

      if (this.szDateRegister && this.szDateRegister.length > 0) {
        this.ancet.sz_date_register = this.formatDate(new Date(this.szDateRegister))
      }
      else {
        this.ancet.sz_date_register = null
      }

      if (this.ancet.id) {
        axios.put(`/ancet/api/ancet/${this.ancet.id}/`, this.ancet, {params: {token: this.tokenInstance}})
          .then(response => {
            this.ancet = response.data
            this.errors = {}
            this.ancetSended = this.ancet.sended
            if (this.ancetSended) {
              window.location.href = `/ancet/p/${this.tokenInstance}/`
            }
          })
          .catch(error => {
            this.errors = error.response.data
            setTimeout(() => this.$scrollTo('.form-group--invalid', 200, {offset: -80}), 500)
          })
      } else {
        axios.post(`/ancet/api/ancet/create/`, this.ancet)
          .then(response => {
            this.ancet = response.data
            this.errors = {}
            this.ancetSended = this.ancet.sended
            if (!this.tokenInstance) {
              this.tokenInstance = this.ancet.link_password
            }
          })
          .catch(error => {
            this.errors = error.response.data
            setTimeout(() => this.$scrollTo('.form-group--invalid', 200, {offset: -80}), 500)
          })
      }
    },

    prepareForm () {
      if (this.ancet) {
        if (this.ancet.ip_date_register) {
          this.ipDateRegister = this.humanizeDate(new Date(this.ancet.ip_date_register))
        }
        if (this.ancet.sz_date_register) {
          this.szDateRegister = this.humanizeDate(new Date(this.ancet.sz_date_register))
        }

        this.tokenInstance = this.ancet.link_password

        if (this.ancet.sended) {
          this.ancetSended = true
        }
      }
    },

    getPasswordLink () {
      var link = this.ancet.get_absolute_url
      navigator.clipboard.writeText(link).then(() => {

        this.copied = true
        
        setTimeout(() => {
          this.copied = false
        }, 1000)

      }, err => {
        console.error('Async: Could not copy text: ', err)
      })
    },

    editAncet () {
      if (this.ancet.id) {
        this.ancet.sended = false
        this.ancetSended = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>